{
  "name": "auth-app",
  "version": "1.0.343",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "node scripts/update-version.js",
    "prebuild:prod": "node scripts/update-version.js",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "update_version": "node scripts/update-version.js",
    "deploy": "node scripts/deploy-collaudo.js",
    "deploy-collaudo": "node scripts/deploy-collaudo.js",
    "deploy-prod": "node scripts/deploy-prod.js"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@10.9.3",
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/localize": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.8",
    "bootstrap-icons": "^1.13.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^13.0.0"
  },
  "devDependencies": {
    "@angular/build": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.1",
    "@types/uuid": "^10.0.0",
    "jsdom": "^27.1.0",
    "typescript": "~6.0.3",
    "vitest": "^4.0.8"
  }
}
